<template>
  <div
    class="incoming-tender-list-row incoming-tender-list-row_breakdown incoming-tender-list-row_breakdown-value"
    :class="{
      'incoming-tender-list-row_breakdown-short': !showLabourMaterialTools,
    }"
    @mouseover="showDeleteRowIcon = true"
    @mouseleave="showDeleteRowIcon = false"
  >
    <div class="tender-list-cell tender-list-cell_numbering">
      <v-tooltip
        v-if="showDeleteRowIcon && versionIsDraft"
        top
        max-width="345"
        transition="scroll-y-transition"
      >
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <TrashIcon
              class="primary-500-icon icon-18px pointer"
              @click="$emit('delete-breakdown-row')"
            />
          </div>
        </template>
        {{ $t('Delete breakdown') }}
      </v-tooltip>
      <span v-else> {{ parentRowIndex + 1 }}.{{ rowIndex + 1 }} </span>
    </div>
    <IncomingTenderListCell
      :row="row"
      :is-number="false"
      field="description_of_works"
      content-editable
      class="tender-list-cell_description"
      is-breakdown
      :order-of-rows-ids="orderOfRowsIds"
      :order-of-fields-to-edit="ORDER_OF_FIELDS_TO_EDIT"
      @edit-cell-value="editCellValue"
    />
    <div class="tender-list-cell tender-list-cell_no-padding">
      <v-select
        :value="row.unit_id"
        :items="units"
        item-value="id"
        item-text="full_name"
        outlined
        hide-details
        background-color="rgba(0, 0, 0, 0)"
        class="unit-select"
        @change="editUnitCell"
      />
    </div>
    <IncomingTenderListCell
      :row="row"
      is-quantity
      field="quantity"
      content-editable
      is-breakdown
      :order-of-rows-ids="orderOfRowsIds"
      :order-of-fields-to-edit="ORDER_OF_FIELDS_TO_EDIT"
      @edit-cell-value="editCellValue"
    />
    <IncomingTenderListCell
      v-for="column in columnKeys"
      :key="column.title"
      :row="row"
      :field="column.title"
      :currency="currency"
      :content-editable="column.canBeEdited"
      is-breakdown
      :class="{ 'right-sticky-cell': column.isSticky }"
      :order-of-rows-ids="orderOfRowsIds"
      :order-of-fields-to-edit="ORDER_OF_FIELDS_TO_EDIT"
      @edit-cell-value="editCellValue"
    />
  </div>
</template>

<script>
  import { VSelect, VTooltip } from 'vuetify/lib';
  import TrashIcon from '@/assets/icons/trash.svg';
  import IncomingTenderListCell from '@/containers/incoming-tender/incoming-tender-list/IncomingTenderListCell';
  import { mapActions, mapState } from 'vuex';

  export default {
    name: 'IncomingTenderListBreakdownRow',
    components: {
      IncomingTenderListCell,
      VSelect,
      VTooltip,
      TrashIcon,
    },
    props: {
      rowIndex: {
        type: Number,
        required: true,
      },
      row: {
        type: Object,
        required: true,
      },
      parentRowIndex: {
        type: Number,
        required: true,
      },
      currency: {
        type: String,
        required: true,
      },
      parentRowId: {
        type: Number,
        required: true,
      },
      columnKeys: {
        type: Array,
        required: true,
      },
      showLabourMaterialTools: {
        type: Boolean,
        required: true,
      },
      versionIsDraft: {
        type: Boolean,
        required: true,
      },
      orderOfRowsIds: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        showDeleteRowIcon: false,
        ORDER_OF_FIELDS_TO_EDIT: [
          'description_of_works',
          'quantity',
          'labour',
          'materials',
          'tools',
        ],
      };
    },
    computed: {
      ...mapState('global', ['units']),
      ...mapState('incomingTender', ['incomingTenderInfo']),
    },
    methods: {
      ...mapActions('incomingTender', ['editIncomingTenderBreakdownCellValue']),
      editCellValue(updatedCell) {
        this.editIncomingTenderBreakdownCellValue({
          parentRowId: this.parentRowId,
          ...updatedCell,
        });
      },
      editUnitCell(unitId) {
        this.editIncomingTenderBreakdownCellValue({
          parentRowId: this.parentRowId,
          rowId: this.row.id,
          key: 'unit_id',
          value: unitId,
        });
      },
    },
  };
</script>
